import { Slide, TextPropsOptions } from '@features/powerpoint';
import { notes as sharedNotes, sharedNotesText } from '../../components/notes';

type NotesProps = {
  options: TextPropsOptions;
};

export const notes = (props: NotesProps): Slide =>
  sharedNotes({
    text: sharedNotesText,
    options: props.options,
  });
